// The E-Docs (Document Library) guide (38_DocumentLibrary.jsx · ModuleHelp, Max 01/11).
const en = {
  uploadT: 'Upload a document',
  uploadB: 'Add a new document or a new version of one that already exists. You see this button only if you may edit the library.',
  searchT: 'Search',
  searchB: 'Type a code, a title or an author to narrow the list. The count beside it shows how many match and how many are still unread.',
  kindT: 'Kind',
  kindB: 'Show only one kind of document, for example procedures or forms. Leave it on All to see everything you may open.',
  foldersT: 'Folders',
  foldersB: 'Pick a folder to list its documents. All documents is everything you can see, and the Catchy shelf lists the documents Catchy reads for staff.',
  listT: 'The documents',
  listB: 'One row per document with its version, change note and update date. Unread ones are marked; open a document to read it and confirm you have read it. Use the funnel on a header to filter.',
};
const ko = {
  uploadT: '문서 업로드',
  uploadB: '새 문서를 올리거나 기존 문서의 새 버전을 추가합니다. 라이브러리 편집 권한이 있을 때만 이 버튼이 보입니다.',
  searchT: '검색',
  searchB: '코드, 제목, 작성자를 입력해 목록을 좁힙니다. 옆의 숫자는 일치하는 건수와 아직 읽지 않은 건수입니다.',
  kindT: '유형',
  kindB: '절차서, 양식 등 한 가지 유형만 보여 줍니다. 전체로 두면 열람 가능한 모든 문서가 나옵니다.',
  foldersT: '폴더',
  foldersB: '폴더를 선택하면 그 안의 문서가 나옵니다. 전체 문서는 볼 수 있는 모든 문서이고, Catchy 선반은 Catchy가 직원용으로 읽는 문서입니다.',
  listT: '문서 목록',
  listB: '문서당 한 행으로 버전, 변경 메모, 수정일이 나옵니다. 읽지 않은 문서는 표시되며, 문서를 열어 읽고 확인할 수 있습니다. 머리글의 깔때기로 필터링합니다.',
};
const vi = {
  uploadT: 'Tải tài liệu lên',
  uploadB: 'Thêm tài liệu mới hoặc phiên bản mới của tài liệu đã có. Nút này chỉ hiện khi bạn có quyền chỉnh sửa thư viện.',
  searchT: 'Tìm kiếm',
  searchB: 'Gõ mã, tiêu đề hoặc tác giả để thu hẹp danh sách. Con số bên cạnh cho biết có bao nhiêu tài liệu khớp và bao nhiêu chưa đọc.',
  kindT: 'Loại',
  kindB: 'Chỉ hiện một loại tài liệu, ví dụ quy trình hoặc biểu mẫu. Để ở All để xem mọi tài liệu bạn được mở.',
  foldersT: 'Thư mục',
  foldersB: 'Chọn một thư mục để xem tài liệu trong đó. All documents là mọi thứ bạn thấy được, còn kệ Catchy liệt kê các tài liệu Catchy đọc để trả lời nhân viên.',
  listT: 'Danh sách tài liệu',
  listB: 'Mỗi dòng là một tài liệu kèm phiên bản, ghi chú thay đổi và ngày cập nhật. Tài liệu chưa đọc được đánh dấu; mở tài liệu để đọc và xác nhận đã đọc. Dùng biểu tượng phễu ở tiêu đề cột để lọc.',
};
const zh = {
  uploadT: '上传文档',
  uploadB: '添加新文档,或为已有文档上传新版本。只有拥有文档库编辑权限的人才能看到这个按钮。',
  searchT: '搜索',
  searchB: '输入编号、标题或作者来缩小列表。旁边的数字显示匹配的数量和尚未阅读的数量。',
  kindT: '类型',
  kindB: '只显示一种类型的文档,例如流程或表单。保持为全部即可看到你有权打开的所有文档。',
  foldersT: '文件夹',
  foldersB: '选择文件夹即可列出其中的文档。All documents 是你能看到的全部文档,Catchy 架列出 Catchy 为员工阅读的文档。',
  listT: '文档列表',
  listB: '每个文档一行,显示版本、变更说明和更新日期。未读的会有标记;打开文档阅读后可确认已读。用列标题上的漏斗进行筛选。',
};
// French and Japanese (task #1173, 2026-11-04) — generated from `en`; a string not yet translated reads English.
const fr = {
  "uploadT": "Importer un document",
  "uploadB": "Ajoutez un nouveau document ou une nouvelle version d'un document existant. Ce bouton n'apparaît que si vous pouvez modifier la bibliothèque.",
  "searchT": "Rechercher",
  "searchB": "Saisissez un code, un titre ou un auteur pour filtrer la liste. Le compteur à côté indique combien de documents correspondent et combien restent non lus.",
  "kindT": "Type",
  "kindB": "N'affichez qu'un seul type de document, par exemple des procédures ou des formulaires. Laissez sur Tous pour voir tout ce que vous pouvez ouvrir.",
  "foldersT": "Dossiers",
  "foldersB": "Choisissez un dossier pour lister ses documents. Tous les documents regroupe tout ce que vous pouvez voir, et l'étagère Catchy liste les documents que Catchy lit pour le personnel.",
  "listT": "Les documents",
  "listB": "Une ligne par document avec sa version, sa note de modification et sa date de mise à jour. Les non lus sont signalés ; ouvrez un document pour le lire et confirmer que vous l'avez lu. Utilisez l'entonnoir d'un en-tête pour filtrer."
};
const ja = {
  "uploadT": "ドキュメントをアップロード",
  "uploadB": "新しいドキュメント、または既存ドキュメントの新しいバージョンを追加します。ライブラリの編集権限がある場合のみ、このボタンが表示されます。",
  "searchT": "検索",
  "searchB": "コード、タイトル、作成者を入力してリストを絞り込みます。横の件数には、一致した件数と未読の件数が表示されます。",
  "kindT": "種類",
  "kindB": "手順書やフォームなど、1種類のドキュメントだけを表示します。「すべて」のままにすると、開けるものがすべて表示されます。",
  "foldersT": "フォルダー",
  "foldersB": "フォルダーを選ぶと、そのドキュメントが一覧表示されます。「すべてのドキュメント」は閲覧できるものすべて、Catchy シェルフは Catchy がスタッフ向けに参照するドキュメントです。",
  "listT": "ドキュメント",
  "listB": "ドキュメントごとに1行で、バージョン、変更メモ、更新日を表示します。未読のものには印が付きます。ドキュメントを開いて読み、読了を確認してください。見出しのフィルターアイコンで絞り込めます。"
};

const dictionary = { ns: 'tourDocs', en, ko, vi, zh, fr, ja };
export default dictionary;
